import React from "react";
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, ArrowRight, Award, Truck, Shield, Palette, CheckCircle, Wrench } from "lucide-react";

const Footer = () => {
  const productCategories = [
    { name: "Floor Tiles", href: "/floor" },
    { name: "Wall Tiles", href: "/wall" },
    { name: "Porcelain Slab", href: "/porcelain-slab" },
    // { name: "High Gloss", href: "/high-gloss" },
    { name: "Elevation Tiles", href: "/elevation" },
    // { name: "Wooden Look", href: "/wooden" }
  ];

  const services = [
    { name: "Design Consultation", icon: <Palette className="w-5 h-5 text-orange-500" /> },
    { name: "Installation Support", icon: <Wrench className="w-5 h-5 text-orange-500" /> }, // Replaced Tool with Wrench
    { name: "Quality Assurance", icon: <CheckCircle className="w-5 h-5 text-orange-500" /> },
    { name: "After Sales Service", icon: <Wrench className="w-5 h-5 text-orange-500" /> }
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-gray-300 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Cpath d="M20 20c0-11.046-8.954-20-20-20v20h20zM0 20v20h20c-11.046 0-20-8.954-20-20z"/%3E%3C/g%3E%3C/svg%3E")'
        }}></div>
      </div>

      <div className="relative z-10">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

            {/* Company Section */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-white mb-2">
                  GMC <span className="text-orange-500">CERAMIC</span>
                </h2>
                <div className="w-16 h-1 bg-orange-500 mb-4"></div>
              </div>

              <p className="text-gray-400 mb-6 leading-relaxed">
                Premium quality ceramic tiles manufacturer with over a decade of excellence.
                Transforming spaces with innovative designs and superior craftsmanship.
              </p>

              {/* Social Links */}
              <div className="flex space-x-4">
                {/* Facebook */}
                <a
                  href="https://www.facebook.com/share/1LpdZFHgDV/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 group"
                >
                  <Facebook className="w-5 h-5 text-gray-400 group-hover:text-white" />
                </a>

                {/* Instagram 1 */}
                <a
                  href="https://www.instagram.com/gmcceramic?igsh=cDh2Znd3MHhyN2Z0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 group"
                >
                  <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white" />
                </a>

                {/* Instagram 2 */}
                <a
                  href="https://www.instagram.com/gmcdecore?igsh=MW40Y3YzaHVsdzl0cw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 group"
                >
                  <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white" />
                </a>

                {/* Twitter */}
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110 group"
                >
                  <Twitter className="w-5 h-5 text-gray-400 group-hover:text-white" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold text-white mb-6 flex items-center">
                Quick Links
                <div className="w-8 h-0.5 bg-orange-500 ml-3"></div>
              </h3>
              <ul className="space-y-3">
                <li>
                  <a
                    href="/"
                    className="flex items-center text-gray-400 hover:text-orange-500 transition-colors duration-300 group"
                  >
                    <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                    <span className="group-hover:translate-x-2 transition-transform duration-300">Home</span>
                  </a>
                </li>
                <li>
                  <a
                    href="/about"
                    className="flex items-center text-gray-400 hover:text-orange-500 transition-colors duration-300 group"
                  >
                    <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                    <span className="group-hover:translate-x-2 transition-transform duration-300">About Us</span>
                  </a>
                </li>
                <li>
                  <a
                    href="/contact"
                    className="flex items-center text-gray-400 hover:text-orange-500 transition-colors duration-300 group"
                  >
                    <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                    <span className="group-hover:translate-x-2 transition-transform duration-300">Contact Us</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Product Categories */}
            <div>
              <h3 className="text-xl font-bold text-white mb-6 flex items-center">
                Our Products
                <div className="w-8 h-0.5 bg-orange-500 ml-3"></div>
              </h3>
              <ul className="space-y-3">
                {productCategories.map((product, index) => (
                  <li key={index}>
                    <a
                      href={product.href}
                      className="flex items-center text-gray-400 hover:text-orange-500 transition-colors duration-300 group"
                    >
                      <ArrowRight className="w-4 h-4 mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                      <span className="group-hover:translate-x-2 transition-transform duration-300">{product.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact & Services */}
            <div>
              <h3 className="text-xl font-bold text-white mb-6 flex items-center">
                Get in Touch
                <div className="w-8 h-0.5 bg-orange-500 ml-3"></div>
              </h3>

              {/* Contact Info */}
              <div className="space-y-4 mb-6">
                <div className="flex items-start space-x-3 group">
                  <MapPin className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                  <div>
                    <p className="text-white font-medium">Visit Our Company</p>
                    <p className="text-gray-400 text-sm">Morbi, Gujarat, India - 363641</p>
                  </div>
                </div>

                <div className="flex items-center space-x-3 group">
                  <Phone className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <div>
                    <p className="text-white font-medium">Call Us Now</p>
                    <a href="tel:+919876543210" className="text-gray-400 text-sm hover:text-orange-500 transition-colors">
                      +91 8575185755
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3 group">
                  <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                  <div>
                    <p className="text-white font-medium">Email Us</p>
                    <a href="mailto:info@gmcceramic.com" className="text-gray-400 text-sm hover:text-orange-500 transition-colors">
                      Newgmcceramic@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Services */}
              <div>
                <h4 className="text-lg font-semibold text-white mb-3">Our Services</h4>
                <div className="grid grid-cols-2 gap-2">
                  {services.map((service, index) => (
                    <div key={index} className="flex items-center space-x-2 text-sm text-gray-400">
                      {service.icon}
                      <span>{service.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bg-gray-900 border-t border-gray-800 py-6">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="text-gray-400 text-sm mb-4 md:mb-0">
                © {new Date().getFullYear()} GMC Ceramic. All rights reserved. | Designed with OneHexa Tech
              </div>
              <div className="flex space-x-6 text-sm">
                <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Privacy Policy</a>
                <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Terms of Service</a>
                <a href="#" className="text-gray-400 hover:text-orange-500 transition-colors">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;